import { useMemo } from "react";
import { useSearchParams } from "react-router";

import { URL_SEARCH_KEY, URL_SORT_DIRECTION, URL_SORT_KEY } from "constants/urlQueryKeys";
import { decodeURIParam } from "utils/urls";
import { SearchQueryOrderDirection } from "types/generated";
import useTypedContext from "hooks/useTypedContext";

import { FiltersContext } from "..";
import { SortOptions } from "./types";

export const useSortOptions = (): SortOptions => {
  const [searchParams] = useSearchParams();
  const { initialSortDirection, initialSortOption, filtersOrder } = useTypedContext(FiltersContext);

  const [querySortOption, querySortDirection] = useMemo(() => {
    const querySortOption = decodeURIParam(searchParams.get(URL_SORT_KEY)) || initialSortOption;
    const querySortDirection = (decodeURIParam(searchParams.get(URL_SORT_DIRECTION)) ||
      initialSortDirection) as SearchQueryOrderDirection;
    return [querySortOption, querySortDirection];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  return {
    sort: { direction: querySortDirection, option: querySortOption },
    text: searchParams.get(URL_SEARCH_KEY),
    order: filtersOrder,
  };
};
